import { defineMessages } from 'react-intl';

export const shipFromFreightDefaultsMessages = defineMessages({
  sectionHeader: {
    id: 'AnqnUn',
    description: 'Header for the Freight Defaults section in the Ship From Location modal',
    defaultMessage: 'Freight Defaults',
  },
  pickupInstructionsLabel: {
    id: '3lMTmG',
    description: 'Label for the pickup instructions textarea in Freight Defaults',
    defaultMessage: 'Pickup Instructions',
  },
  pickupInstructionsPlaceholder: {
    id: 'jEcr8Y',
    description: 'Placeholder for the pickup instructions textarea in Freight Defaults',
    defaultMessage: 'Enter any special pickup instructions for the carrier',
  },
  addPickupInstructionsLink: {
    id: 'wPAs7z',
    description: 'Toggle link that reveals the pickup instructions textarea in Freight Defaults',
    defaultMessage: 'Add Pickup Instructions',
  },
});
